import React from "react";
import { SERVICES, makeNavLink } from "../shared.jsx";
import { nl } from "./nl.jsx";

// Sekcja "Co robimy". Edytowalne: nagłówek sekcji, CTA, kafelek partnera.
// Lista 7 usług pochodzi z SERVICES (shared.jsx) — wspólna między stronami, nieedytowalna tutaj.
const noop = () => {};

export function HomeServices({
  eyebrow = "",
  headingBefore = "",
  headingHighlight = "",
  headingAfter = "",
  cta = "",
  partner = {},
  navigate,
  reveal = true,
}) {
  const nav = navigate || noop;
  const link = makeNavLink(nav);
  const go = (r) => () => nav(r);
  const rv = reveal ? " rv" : "";
  return (
    <section className="sec container">
      <div className="section-title-row">
        <div>
          <span className="section-eyebrow">{eyebrow}</span>
          <h2 className={"h2" + rv}>{nl(headingBefore)}<span className="hl hl-paint">{headingHighlight}</span>{nl(headingAfter)}</h2>
        </div>
        <button className="lc-btn lc-btn-ghost" onClick={go("/uslugi")}>
          {cta} <span className="lc-btn-arr">↗</span>
        </button>
      </div>
      <ul className="svc-list">
        {SERVICES.map((s) => (
          <li key={s.slug} className="svc-item-li">
            <a className={"svc-item" + rv} {...link(`/uslugi/${s.slug}`)}>
              <span className="svc-k">{s.k}</span>
              <div>
                <h3 className="svc-name">{s.name}</h3>
                <p className="svc-desc">{s.desc}</p>
              </div>
              <span className="svc-meta">{s.meta}</span>
              <span className="svc-arr">↗</span>
            </a>
          </li>
        ))}
        {/* kafelek partnera (08) — edytowalny */}
        <li className="svc-item-li">
          <a className={"svc-item" + rv} href={partner.href || "#"} target="_blank" rel="noopener noreferrer">
            <span className="svc-k">{partner.k}</span>
            <div>
              <h3 className="svc-name">{partner.name}</h3>
              <p className="svc-desc">{partner.desc}</p>
            </div>
            <span className="svc-meta">{partner.meta}</span>
            <span className="svc-arr">↗</span>
          </a>
        </li>
      </ul>
    </section>
  );
}
